export const theme = {
  fontFamily: {
    base: 'Swiss721-BT,Helvetica,Arial,sans-serif',
    title: 'Swiss721-BT-Medium, Helvetica,Arial,sans-serif',
    body: 'Swiss721-BT-Regular, Helvetica,Arial,sans-serif',
    heading: 'Swiss-721-Condense,Helvetica,Arial,sans-serif',
    icon: 'MarriottIconsNew',
  },
};
